import {AB_TEST_HEADERS, extendWithAbTests} from '@aboutyou/feature-flags';
import {parseCookies} from '@aboutyou/storage';
import {Request} from 'express';

export interface CookieConfig {
  whitelistedCookies: string[];
}

export const parseRequestCookies = (req: Request, config?: CookieConfig) => {
  const AYActiveABTestsHeader = req.get(AB_TEST_HEADERS.AYActiveABTests);
  const cookies = parseCookies({
    cookieString: req.headers.cookie,
    whitelistedCookies: config?.whitelistedCookies || null,
  });
  return extendWithAbTests(cookies, AYActiveABTestsHeader);
};
